import { render, staticRenderFns } from "./TeacherMainPage.vue?vue&type=template&id=ddc27e86&scoped=true&"
import script from "./TeacherMainPage.vue?vue&type=script&lang=ts&"
export * from "./TeacherMainPage.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherMainPage.vue?vue&type=style&index=0&id=ddc27e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc27e86",
  null
  
)

export default component.exports